import { render } from "./App.vue?vue&type=template&id=9c23d850"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9c23d850&lang=scss"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__